<template>

    <div >
    
  
 
        <!-- 选择区域 -->
        <div class="mb-8 grid grid-cols-2 gap-6"  style="height: 250px;">
          <!-- 仓库选择 -->
          <div class="rounded-lg bg-white shadow-sm" style="overflow-y: auto;height: 250px;">
            <h2 class="mb-4 text-lg font-medium text-gray-900">选择仓库</h2>
            <div class="space-y-3">
              <div v-for="(warehouse, index) in WarehouseList" :key="index" 
                   class="flex cursor-pointer items-center rounded-lg border p-4 transition-all hover:border-blue-500"
                   :class="{'border-blue-500 bg-blue-50': selectedWarehouse === warehouse.warehouse_id, 'border-gray-200': selectedWarehouse !== warehouse.warehouse_id}"
                   @click="selectWarehouse(warehouse.warehouse_id)">
                <i class="fa-solid fa-warehouse mr-3 text-xl" :class="{'text-blue-500': selectedWarehouse === warehouse.warehouse_id, 'text-gray-400': selectedWarehouse !== warehouse.warehouse_id}"></i>
                <div>
                  <p class="font-medium" :class="{'text-blue-600': selectedWarehouse === warehouse.warehouse_id}">{{ warehouse.name }}</p>
                  <p class="text-sm text-gray-500">{{ warehouse.address }}</p>
                </div>
              </div>
            </div>
          </div>
  
          <!-- 库位选择 -->
          <div class="rounded-lg bg-white p-6 shadow-sm"  style="overflow-y: auto;height: 250px;">
            <h2 class="mb-4 text-lg font-medium text-gray-900">选择库位</h2>
            <div class="space-y-3">
              <div v-for="(location, index) in filteredLocations" :key="index"
                   class="flex cursor-pointer items-center rounded-lg border p-4 transition-all hover:border-blue-500"
                   :class="{'border-blue-500 bg-blue-50': selectedLocation === location.warehouse_kw_id, 'border-gray-200': selectedLocation !== location.warehouse_kw_id}"
                   @click="selectLocation(location.warehouse_kw_id)">
                <i class="fa-solid fa-box-archive mr-3 text-xl" :class="{'text-blue-500': selectedLocation === location.warehouse_kw_id, 'text-gray-400': selectedLocation !== location.warehouse_kw_id}"></i>
                <div>
                  <p class="font-medium" :class="{'text-blue-600': selectedLocation === location.warehouse_kw_id}">{{ location.name }}</p>
                  <p class="text-sm text-gray-500">编号：{{ location.numb }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>


    
    </div>
  </template>
  
  <script>

    import WarehouseApi from '@/api/warehouse.js';
 
    export default {

      inject: ['reload'],
      data() {
        return {
        
  
  
          search:"",
          WarehouseList:[],
          warehousekw:[],
          currentRow :null,
          selectedWarehouse:0,
          selectedLocation:0,
        };
      },
      created() {
        var self  =this;
        setTimeout(() => {
          if(self.WarehouseList.length <= 0){
            self.getWarehouse();
          }
        }, 200);
      
 
 
      },
      watch:{
        choose_supply_id:function(n,o){
        if(n!=o){
          if(n){
            this.getWarehouse();
          }
        }
      }
    },
      computed: {
            filteredLocations() {
                if (!this.selectedWarehouse) return [];
                var warehousekw = [];
                for(var i=0;i<this.WarehouseList.length;i++){
                    if(this.WarehouseList[i].warehouse_id === this.selectedWarehouse){
                        warehousekw = this.WarehouseList[i].children;
                    }
                }
                
                return warehousekw;
            },
        },
      props:['choose_supply_id'],
      methods: {

        handleCurrentChange(val) {
            console.log('val',val)
        //     this.currentRow = val;
 
        //    let self = this;
   
        //    this.$emit("handleCurrentChange", { openDialog: false,
        //     "warehouse_id":val.warehouse_id,
        //     "warehouse_kw_id":val.warehouse_kw_id
        //     });
      },

        selectWarehouse(id) {
            this.selectedWarehouse = id;
            this.selectedLocation = null;
      },
      selectLocation(id) {
          
            this.selectedLocation = id;
            this.$emit("handleCurrentChanges", { 
                    openDialog: false,
                    "warehouse_id": this.selectedWarehouse,
                    "warehouse_kw_id": this.selectedLocation
            });
      },
        getWarehouse() {
            let self = this;
            self.loading = true
            let Params = {}
            Params.page = 1
            Params.list_rows = 9000
            Params.search = self.search
            Params.choose_supply_id = self.choose_supply_id;
            WarehouseApi.list(Params, true)
              .then(data => {
                self.loading = false
                self.WarehouseList = data.data.list.data
                this.selectedWarehouse = self.WarehouseList[0].warehouse_id;
              })
              .catch(error => {
                self.loading = false
              });
      },
      }
    };
  </script>
  
  <style>

  
</style>
  


// WEBPACK FOOTER //
// src/components/select/cwarehouse.vue